import { RussiaIcon, UkIcon } from '../ui/icons/flags';

import { Language } from './language';

export const LANGUAGES_LIST = {
  [Language.English]: {
    icon: UkIcon,
    label: 'English',
    value: Language.English,
  },
  [Language.Russian]: {
    icon: RussiaIcon,
    label: 'Russian',
    value: Language.Russian,
  },
};

export { LANG_STORAGE_KEY, Language, LANGUAGES } from './language';
